/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable , BehaviorSubject} from 'rxjs';
import {AppConfig} from '../../app.config';
@Injectable()
export class TemplatesService  {
  communications: any[];
  onCommunicationChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor (private http: HttpClient , private api: AppConfig) {

  }

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve (route: ActivatedRouteSnapshot , state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return new Promise<void>((resolve , reject) => {

      Promise.all([
        this.getTags()
      ]).then(
        () => {
          resolve();
        } ,
        reject
      );
    });
  }

  getTags () {
    return new Promise((resolve , reject) => {
      this.http.get(this.api.baseUrl + '/communicationData/templatesAll' , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          response.map((item) => {
            if (item.data) {
              item.data = JSON.parse(item.data);
            }
            // if (item.type === 'sms') {
            //   item.dataForShow = item.data['numbers'].split(',');
            // }
            // if (item.type === 'mail') {
            //   item.dataForShow = item.data['mails'].split(',');
            // }
            // if (item.type === 'serial') {
            //   item.dataForShow = item.data['userInfo'];
            // }
          });

          this.communications = response;
          this.onCommunicationChanged.next(this.communications);
          resolve(response);
        } , reject);
    });

  }
}

